<template lang="pug">
.dados-relatorio-rastreabilidade
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportData') }}
    .row.m-0
        .dados-relatorio-form
            el-form(ref="dadosRelatorioForm", :model="dadosRelatorio", :inline="true", label-position="top", class="form-alignment")
                .numero-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber') }}
                        span.required *
                    el-form-item(prop="numeroRelatorio", :rules="numeroRelatorioRules")
                        el-input(
                            v-model='dadosRelatorio.numeroRelatorio'
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber')"
                            type='number'
                            maxlength='11'
                            @keydown.native="blockInvalidChars"
                            @input="limitQuantity('numeroRelatorio', 11)"
                        )

                .cultura
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.crop') }}
                        span.required *
                    el-form-item(prop="culturaSelecionada", :rules="culturaSelecionadaRules")
                        el-select(
                            v-model='dadosRelatorio.culturaSelecionada',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            value-key='id',
                            class="custom-select-cultura"
                            disabled
                        )
                            el-option(
                                v-for='cultura in culturas',
                                :key='cultura.id',
                                :value='cultura',
                                :label='cultura.nome'
                            ) {{ cultura.nome }}

                .volume
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume') }}
                        span.required *
                    el-form-item(prop="volume", :rules="volumeRules")
                        el-input(
                            v-model='dadosRelatorio.volume',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume')",
                            type='number',
                            maxlength='18'
                            @keydown.native="blockInvalidChars"
                            @input='emitVolume'
                        )

                .data-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportDate') }}
                        span.required *
                    el-form-item(prop="dataRelatorio", :rules="dataRelatorioRules")
                        el-date-picker(
                            v-model='dadosRelatorio.dataRelatorio',
                            class='custom-date-picker',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                        )
</template>

<script>
import EventBus from '@/utils/eventBus';
import culturaService from '@/services/CulturaService';

export default {
    name: 'ReportDataDefault',
    data() {
        return {
            totalizerValues: [],
            volumeDisponivel: null,
            dadosRelatorio: {
                numeroRelatorio: null,
                culturaSelecionada: null,
                volume: null,
                dataRelatorio: null
            },
            culturas: [],
            errors: {
                numeroRelatorio: false,
                culturaSelecionada: false,
                volume: false,
                dataRelatorio: false
            },
            formValid: false,
            requiredField: this.$t('relatorio_rastreabilidade.messages.common.validation.requiredField')
        };
    },
    computed: {
        numeroRelatorioRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        },
        culturaSelecionadaRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        },
        volumeRules() {
            return [
                { required: true, message: this.requiredField, trigger: 'change' },
                { validator: this.validarVolume, trigger: 'change' }
            ];
        },
        dataRelatorioRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        }
    },
    watch: {
        dadosRelatorio: {
            handler(newVal) {
                EventBus.$emit('report-valid-data', newVal);
            },
            deep: true
        }
    },
    mounted() {
        this.buscaCulturas();
        EventBus.$on('totalizer-updated', this.passDataToContractList);
    },
    methods: {
        blockInvalidChars(event) {
            const allowedKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
            ];
            const invalidKeys = ['e', 'E', '-', '+', '.'];

            if (allowedKeys.includes(event.key)) {
                return;
            }

            if (invalidKeys.includes(event.key) || !/^[0-9]$/.test(event.key)) {
                event.preventDefault();
            }
        },
        limitQuantity(field, maxLength) {
            const value = this.dadosRelatorio[field]?.toString() || '';
            if (value.length > maxLength) {
                this.dadosRelatorio[field] = value.slice(0, maxLength);
            }
        },
        passDataToContractList(data) {
            this.totalizerValues = data;
            this.volumeDisponivel = data[1];
        },
        emitVolume() {
            if (this.dadosRelatorio.volume < 0) {
                this.dadosRelatorio.volume = 0;
            }

            if (this.dadosRelatorio.volume.length > 11) {
                this.dadosRelatorio.volume = this.dadosRelatorio.volume.slice(0, 11);
            }
            EventBus.$emit('volume-input-updated', this.dadosRelatorio.volume);
        },
        async buscaCulturas() {
            await culturaService.findCultura().then(({ data }) => {
                const soja = data.find(cultura => cultura.nome.toLowerCase() === 'soja');
                if (soja) {
                    this.dadosRelatorio.culturaSelecionada = soja;
                }
                this.culturas = data;
            });
        },
        validarVolume(rule, value, callback) {
            if (value > this.volumeDisponivel) {
                const message = this.$t('relatorio_rastreabilidade.messages.common.validation.availableVolume');
                callback(new Error(message));
            } else {
                callback();
            }
        },
        validarFormulario() {
            this.$refs.dadosRelatorioForm.validate(valid => {
                if (!valid) {
                    this.formValid = false;
                } else {
                    this.formValid = true;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.dados-relatorio-rastreabilidade {
    margin-top: 15px;
}
.dados-relatorio-title {
    font-size: 16px;
    font-weight: 500;
}
.dados-relatorio-subtitle {
    font-size: 14px;
    font-weight: 400;
}
.dados-relatorio-form {
    width: 100%;
    background-color: var(--white);
    border-radius: 6px;
    padding: 15px;
}
.section-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: var(--primary-font-color);
}
.form-alignment {
    display: flex;

    .required {
        margin-left: 2px;
        color: var(--red)
    }
    .numero-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .volume {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .cultura {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .data-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
    }

    .custom-select-cultura {
        width: 100%;
    }
    .custom-date-picker {
        width: 100% !important;
    }
}

.is-invalid {
    border-color: var(--red);
}
.text-danger {
    color: var(--red);
    font-size: 12px;
}
</style>
